<mat-hint *ngIf="showHint">
  <app-mark-in-circle-logo
    [mark]="'!'"
  ></app-mark-in-circle-logo>
  Are you sure? If yes, please proceed.
</mat-hint>
